var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6628 13.995V12.6622C10.6628 11.9552 10.3819 11.2772 9.88201 10.7772C9.38209 10.2773 8.70406 9.99646 7.99706 9.99646H3.99848C3.29149 9.99646 2.61345 10.2773 2.11353 10.7772C1.61362 11.2772 1.33276 11.9552 1.33276 12.6622V13.995",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99775 7.33071C7.46999 7.33071 8.66347 6.13722 8.66347 4.66499C8.66347 3.19275 7.46999 1.99927 5.99775 1.99927C4.52551 1.99927 3.33203 3.19275 3.33203 4.66499C3.33203 6.13722 4.52551 7.33071 5.99775 7.33071Z",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6614 13.995V12.6622C14.661 12.0715 14.4644 11.4977 14.1025 11.0309C13.7406 10.5641 13.234 10.2307 12.6621 10.0831",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6628 2.08594C11.2362 2.23275 11.7445 2.56623 12.1074 3.03381C12.4704 3.50138 12.6674 4.07645 12.6674 4.66835C12.6674 5.26026 12.4704 5.83533 12.1074 6.3029C11.7445 6.77047 11.2362 7.10395 10.6628 7.25077",
    stroke: "#4A5565",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser4);
export default __webpack_public_path__ + "static/media/User4.0764084caa5c0ba8523b9952cfa6ff30.svg";
export { ForwardRef as ReactComponent };